interface MapLayerReference {
	id?: number
	layer_type?: string
}

export const isItemOnMapLayer = (
	itemLayerId: number | null | undefined,
	selectedLayerId: number,
	layers: MapLayerReference[],
): boolean => {
	if (itemLayerId === selectedLayerId) return true
	if (layers.find(layer => layer.id === selectedLayerId)?.layer_type !== 'georeferenced') return false

	// Match the native app: show geographic pins with missing or default layer references.
	const itemLayer = layers.find(layer => layer.id === itemLayerId)
	return !itemLayer || itemLayer.layer_type === 'mapbox'
}

export const hasMapCoordinates = (item: { lat?: number | string | null; lng?: number | string | null }): boolean =>
	[item.lat, item.lng].every(value => value != null && String(value).trim() !== '' && Number.isFinite(Number(value)))
